import { render } from "./ProductAddEdit.vue?vue&type=template&id=b1780092"
import script from "./ProductAddEdit.vue?vue&type=script&lang=js"
export * from "./ProductAddEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__